// Force-Build: 5
import appEnv from 'bundles/front-page/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
